/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {generateCountryCodeMap} from '../../../../common/utils/countryUtils';
import {generateUUID} from '../../../../common/utils/functions';
import {initModalData} from '../../../../data/constants/Assurance/AssuranceRapatriement/souscription';
import {countryData} from '../../../../data/constants/country';
import {ApiResponse} from '../../../../data/types/interface/api';
import {DevisRapatriementParam} from '../../../../data/types/interface/Assurance/AssuranceRapatriement/devis';
import {
  IAssured,
  IValues,
  ModalDataDTO,
} from '../../../../data/types/interface/Assurance/AssuranceRapatriement/souscription';
import {StackParams} from '../../../../data/types/navigation';
import {RapatriementServices} from '../../../../services/applicatif/rapatriement';
import mapDispatchToProps from '../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../../components/Header/HeaderScreen';
import {Header} from '../../../components/Header/HeaderSouscriptionRapatriement';
import {Loader} from '../../../components/Loader';
import ConfirmationModal from '../../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../../components/PageContainer';
import {ConfirmationRapatriement} from './Confirmation';
import {Form} from './Forms/FormWeb';

dayjs.extend(CustomParseFormat);

type NavigationProps = StackNavigationProp<StackParams>;
// TODO: verify data to send, + lay id rehefa mi update
const FSouscriptionAssuranceRapatriementForm = (props: any) => {
  const {
    contratEnCoursUser,
    checkOrangeTransactionUser,
    checkTelmaTransactionUser,
    user,
  } = props;

  const {navigate, goBack} = useNavigation<NavigationProps>();
  const {souscrireContrat, redoDevis} = RapatriementServices();

  const [IsLoading, setIsLoading] = useState(false);

  const {params}: any = useRoute();
  const beneficiaires: Partial<IAssured>[] = params.beneficiaires || [];

  const codeCountryMap = generateCountryCodeMap(countryData);

  const currentUser = user?.data?.utilisateur;
  const contratId = params.contrat;
  const policyNumber = params.numeroPolice;
  const simulationId = params?.simulationId;
  const isRenewal = !!(contratId && policyNumber);

  useFocusEffect(
    useCallback(() => {
      if (!currentUser) {
        navigate('Login', {
          data: 'SouscriptionAssuranceRapatriement',
          params: {
            dateDebut: params.dateDebut,
            beneficiaires: params.beneficiaires,
            contrat: params.contrat,
            numeroPolice: params.numeroPolice,
            simulationId: params.simulationId,
          },
        });
      }
    }, [currentUser]),
  );

  const showError = useCallback((message: string) => {
    setErrorMessage(() => message);
    setShowErrorModal(() => true);
  }, []);

  const initDataDto: IValues = {
    userIsAssured: false,
    quoteCode: params?.quoteCode,
    isRenewal,
    dateDebut: params?.dateDebut || '',
    assure: beneficiaires.map(elt => ({
      id: elt.id || generateUUID(),
      nom: elt.nom || '',
      prenom: elt.prenom || '',
      dateNaissance:
        typeof elt.dateNaissance == 'object'
          ? elt.dateNaissance
          : dayjs(elt.dateNaissance, 'YYYY-MM-DD').toDate(),
      sexe: elt.sexe || '',
      adressePostale: elt.adressePostale || '',
      ville: elt.ville || '',
      paysResidence: elt.paysResidence || '',
      email: elt.email || '',
      telephone: elt.telephone || '',
      countryCode: codeCountryMap[elt.paysResidence || ''] ?? 'FR',
      numCI: elt.numCI || '',
      capture_file: elt.capture_file,
      lastCaptureFile: elt.lastCaptureFile || '',
      newImage: elt.newImage || false,
      isEditable: !isRenewal,
      isNew: !isRenewal,
    })),
  };
  const [dataDto, setDataDto] = useState<IValues>({...initDataDto});

  const [currentScreen, setCurrentScreen] = useState<'form' | 'validation'>(
    'form',
  );
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [modalData, setModalData] = React.useState<ModalDataDTO>({
    ...initModalData,
  });

  const initScreen = () => {
    setCurrentScreen('form');
  };

  useEffect(() => {
    checkOrangeTransactionUser('echoue', () => {});
    checkTelmaTransactionUser('echoue', () => {});
    initScreen();
  }, [params]);

  const handleCancel = () => {
    goBack();
  };

  const handleSubmit = (response: IValues) => {
    setIsLoading(true);
    console.log('submit', response, isRenewal);

    if (isRenewal) {
      console.log(contratId, policyNumber, simulationId, response);

      if (response.devis?.tarificationTotale) {
        contratEnCoursUser({
          ...response,
          primeTTC: Math.ceil(
            response.devis?.tarificationTotale.primeTtcTotaleMGA,
          ),
          typeContrat: 'rapatriement',
          typePayment: 'renouvellement',
          numeroPolice: policyNumber,
          dateEffet: response.dateDebut,
          rapatriement: {
            assure: response.assure,
            dateDebut: response.dateDebut,
            montant: response.devis.tarificationTotale.primeTtcTotaleMGA,
            numeroPolice: policyNumber,
            simulationId,
            contratId,
          },
        });
        setModalData({
          status: true,
          title: 'Assurance obsèques à dago',
          content:
            'Pour finaliser votre renouvellement, veuillez procéder au paiement.',
          btn1: 'OK',
          btn2: undefined,
          handleBtn1: () => {
            setModalData({...initModalData});
            redirectToPayment();
          },
          handleBtn2: undefined,
        });
      } else {
        setModalData({
          status: true,
          title: 'Erreur',
          content: `Montant de l'assurance non fourni, veuillez le recalculer.`,
          btn1: 'OK',
          btn2: undefined,
          handleBtn1: () => {
            setModalData({...initModalData});
          },
          handleBtn2: undefined,
        });
      }
      setIsLoading(false);
    } else {
      const preparedData = {
        // agence: response.agence,
        dateEffect: response.dateDebut,

        beneficiaires: response.assure.map(currentAssure => {
          return {
            ...currentAssure,
            dateNaissance: currentAssure.dateNaissance,
            lastCaptureFile: currentAssure.lastCaptureFile || '',
            newImage: currentAssure.newImage || false,
          };
        }),
      };

      souscrireContrat(preparedData)
        .then((res: any) => {
          setIsLoading(false);
          if (res?.data?.simulationId) {
            if (response.devis?.tarificationTotale) {
              contratEnCoursUser({
                ...response,
                primeTTC: Math.ceil(
                  response.devis?.tarificationTotale.primeTtcTotaleMGA,
                ),
                typeContrat: 'rapatriement',
                typePayment: isRenewal ? 'renouvellement' : 'souscription',
                simulationId: res?.data?.simulationId,
              });
              setModalData({
                status: true,
                title: 'Assurance obsèques à dago',
                content:
                  'Pour finaliser votre souscription, veuillez procéder au paiement.',
                btn1: 'OK',
                btn2: undefined,
                handleBtn1: () => {
                  setModalData({...initModalData});
                  redirectToPayment();
                },
                handleBtn2: undefined,
              });
            } else {
              setModalData({
                status: true,
                title: 'Erreur',
                content: `Montant de l'assurance non fourni, veuillez le recalculer.`,
                btn1: 'OK',
                btn2: undefined,
                handleBtn1: () => {
                  setModalData({...initModalData});
                },
                handleBtn2: undefined,
              });
            }
          } else {
            setErrorMessage(res.message || 'Erreur lors de la souscription');

            setShowErrorModal(true);
          }
        })
        .catch(err => {
          setErrorMessage(err.message || 'Erreur lors de la souscription');
          setShowErrorModal(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const redoDevisAndContinue = (
    data: DevisRapatriementParam[],
    response: any,
  ) => {
    redoDevis(data, response.dateDebut)
      .then((res: ApiResponse) => {
        if (!res.isError && res.data) {
          const {totaux, ...restDevis} = res.data;
          setDataDto(() => ({
            ...response,
            devis: {
              ...restDevis,
              tarificationTotale: totaux,
            },
          }));
          setCurrentScreen('validation');
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleGoToValidation = (response: any) => {
    setIsLoading(true);

    const dataToSend = (response.assure as IAssured[]).map(a => ({
      dateNaissance: dayjs(a.dateNaissance).format('YYYY-MM-DD'),
      paysResidence: a.paysResidence,
    }));
    redoDevisAndContinue(dataToSend, response);
    setModalData({...initModalData});
  };

  const redirectToPayment = () => {
    setModalData({...initModalData});
    navigate('Payement');
  };

  return (
    <View>
      <HeaderScreen
        title={`${
          isRenewal ? 'Renouveller' : 'Souscrire'
        } assurance obsèques à dago`}
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {modalData.status ? (
          <ConfirmationModal
            title={modalData.title}
            content={modalData.content}
            btn1={modalData.btn1}
            btn2={modalData.btn2}
            handleBtn1={modalData.handleBtn1}
            handleBtn2={modalData.handleBtn2}
          />
        ) : null}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading ? <Loader /> : null}

        {/** Header content */}
        {!IsLoading && !modalData.status && currentScreen === 'form' ? (
          <Header isRenewal={isRenewal} />
        ) : null}

        {/** Form content */}
        {!modalData.status && !IsLoading && currentScreen === 'form' ? (
          <Form
            data={dataDto}
            initData={initDataDto}
            setData={setDataDto}
            onCancelForm={handleCancel}
            onSubmitForm={handleGoToValidation}
          />
        ) : null}
        {!modalData.status && !IsLoading && currentScreen === 'validation' ? (
          <ConfirmationRapatriement
            data={{
              ...dataDto,
              adresse: user?.data?.utilisateur?.adresse,
              quoteCode: dataDto.quoteCode,
            }}
            onCancel={() => {
              setCurrentScreen('form');
            }}
            onSubmit={handleSubmit}
            showError={showError}
            isRenewal={isRenewal}
          />
        ) : null}
      </PageContainer>
    </View>
  );
};

export const SouscriptionAssuranceRapatriement: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSouscriptionAssuranceRapatriementForm);
